import React, { useEffect } from 'react';
import { Outlet } from 'react-router';
import { RoutingPage, setPage } from '../../routes/routerSlice';
import AdministrationHeader from './navigation/AdministrationHeader';
import { MainContent, MainContentWrapper } from '@ydistri/ds';
import { useAppDispatch } from '../../store';

const ProjectAdministration: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setPage(RoutingPage.PROJECT_ADMINISTRATION));
  }, [dispatch]);

  return (
    <>
      <AdministrationHeader />
      <MainContentWrapper data-type="ProjectAdministrationContentWrapper">
        <MainContent data-type="ProjectAdministrationContent">
          <Outlet />
        </MainContent>
      </MainContentWrapper>
    </>
  );
};

export default ProjectAdministration;
